import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length && !roles.includes(user.role)) return <Navigate to="/" replace />;
  if (user.must_change_password) {
    if (location.pathname !== '/force-change-password') {
      return <Navigate to="/force-change-password" replace />;
    }
  }
  return <Outlet />;
}
